export default __webpack_public_path__ + "static/media/pic5.2cee5805.jpg";